/*
 * File: 微信浏览器中打开的提示组件 提示用户用浏览器打开
 * File Created: 2021-05-13 11:59:24 am
 * Author: huangxl (huangxl20@meicloud.com)
 * -----
 * Last Modified: 2021-05-24 11:53:39 am
 * Modified By: huangxl (huangxl20@meicloud.com)
 */

<template>
  <div class="wechat-tips">
    <overlay
      :show="show"
      v-on="$listeners">
      <div
        class="browser-icon"
        :style="iconStyle">
        <img
          v-if="isIOS"
          src="../../assets/images/icons/safari.png"
          alt=""
          width="47"
          height="48"
        >
        <div
          v-else
          class="icon">
          <img
            :src="isPC
              ? require('@/assets/images/icons/wechat-pc-bw.png')
              : require('@/assets/images/icons/wechat-earth.png')"
            alt=""
            width="47"
            height="47"
          >
        </div>
        <span>{{ isIOS ? $t('common.plsOpenInSafari') : $t('common.plsOpenInBrowser') }}</span>
      </div>
      <img
        class="arrow"
        :style="arrowStyle"
        :src="isPC
          ? require('@/assets/images/icons/wechat-arrow-left.png')
          : require('@/assets/images/icons/wechat-arrow-right.png')"
        alt=""
      >
    </overlay>
  </div>
</template>

<script>
import { Overlay } from 'vant'
import device from 'mds-libs/libs/common/utils/device/src/index.js'
import { isPC } from '@/utils'
export default {
  name: 'wechat-tips',
  components: {
    Overlay
  },
  props: {
    isShow: Boolean
  },
  data() {
    return {
      isIOS: device.isIOS(),
      isPC: isPC(),
    }
  },
  computed: {
    show: {
      get() {
        return this.isShow
      },
      set(val) {
        this.$emit('update:isShow', val)
      }
    },
    iconStyle() {
      return this.isPC ? {
        left: '170px'
      } : {
        right: '60px'
      }
    },
    arrowStyle() {
      return this.isPC ? {
        left: '185px'
      } : {
        right: '30px'
      }
    }
  }
}
</script>

<style lang='less' scoped>
  .wechat-tips {
    position: relative;
    .arrow {
      position: absolute;
      top: 5px;
      width: 65px;
      height: 99px;
    }
    .browser-icon {
      position: absolute;
      top: 95px;
      z-index: 2;
      display: flex;
      flex-direction: column;
      align-items: center;
      .icon {
        width: 47px;
        height: 47px;
        background-color: #fff;
        border-radius: 11px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 4px;
      }
      & > span {
        font-size: 16px;
        color: #fff;
      }
    }
  }
</style>
